/**
 * Loads Ad Library and initializes ad modules.
 */

import Admiral from './modules/admiral'
import golfAds from './modules/golf-ads'

Admiral.init()
golfAds.init()
